import { Tooltip as ReactTooltip, ITooltip } from "react-tooltip";
import classNames from "classnames";

interface TooltipProps extends ITooltip {
  asNav?: boolean;
}

const Tooltip = ({ asNav = false, ...rest }: TooltipProps) => {
  return (
    <ReactTooltip
      className={classNames("tooltip", asNav && "tooltip--as-nav")}
      {...rest}
    />
  );
};

export { Tooltip };
